import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Md5} from 'ts-md5/dist/md5';
import * as CryptoJS from 'crypto-js';
import {Globals} from '.././globals';

@Injectable()
export class sessionService {
  user:any;
  constructor(private http: HttpClient,private _global:Globals) {
    
  }
  readonly rootUrl = this._global.siteUrl;
  addsession(session){
    const body = {
     sessionName: session.sessionName,
     status: session.status,
     createdBy:session.userid
     }
     console.log(body);
     return this.http.post(this.rootUrl + 'session/addsession', body);
 }
 getsession(start,end,searchtxt){
  
 return this.http.get(this.rootUrl + "session/getsession?start="+start+"&end="+end+'&search='+searchtxt);

}

editsession(sessid){
  return this.http.get(this.rootUrl+"session/getsessionedit?cid="+btoa(sessid));
}


editsavesess(session,sessid){

  let body = {
     id:sessid,
     sessionName: session.sessionName,
     status: session.status,
     createdBy:session.userid
  };

  return this.http.post(this.rootUrl + 'session/editsavesess', body);

}

delsess(sessid){
   const body = {
    id: sessid,
    isDeleted:1
  }
  return this.http.post(this.rootUrl + 'session/delsess', body);
}

//center services
usersession(sessionId){
  return this.http.get(this.rootUrl+'session/getsessionlist?cid='+btoa(sessionId));
}

userstate(){
  return this.http.get(this.rootUrl+'session/getstatelist');
}
usercity(stateId){
  var data = "state=" + btoa(stateId);
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded'});
  return this.http.post(this.rootUrl+'session/getcitylist', data,{ headers: reqHeader});
}


addcenter(centerObj){
  const body = {
    centerName:centerObj.Center,
    centerState:centerObj.State,
    centerCity:centerObj.City,
    centerAddress:centerObj.Address,
    centerMobile:centerObj.Mobile,
    centerEmail:centerObj.Email,
    status:centerObj.Status,
    latitude:centerObj.lat,
    longitude:centerObj.lng,
    createdBy:centerObj.userid
  }
 
  return this.http.post(this.rootUrl + 'session/addcenter', body);
}

editcenterr(centerObj,centerId){
  const body = {
    centerName:centerObj.Center,
    centerState:centerObj.State,
    centerCity:centerObj.City,
    centerAddress:centerObj.Address,
    centerMobile:centerObj.Mobile,
    centerEmail:centerObj.Email,
    status:centerObj.Status,
    latitude:centerObj.lat,
    longitude:centerObj.lng,
    createdBy:centerObj.userid,
    id:centerId
  }
  return this.http.post(this.rootUrl + 'session/editcenter', body);
}

centerlist(start,end,searchtxt){
    return this.http.get(this.rootUrl+"session/centerlist?start="+start+"&end="+end+'&search='+searchtxt);

}

editcenter(centerId){
  return this.http.get(this.rootUrl+"session/getcenter?cid="+btoa(centerId));
}

delCenter(centerId){
  const body = {
   id: centerId,
   isDeleted:1
 }
 return this.http.post(this.rootUrl + 'session/delcenter', body);
}
 
//Stream

usercenter(centerId,user){
  var center = user.centerId;
  return this.http.get(this.rootUrl+'session/getcenterlist?cid='+btoa(centerId)+'&center='+center);
  
}

usersubject(subjectId){
  return this.http.get(this.rootUrl+'session/getsubjectlist?cid='+btoa(subjectId));
  
}

usercourse(courseId){
  return this.http.get(this.rootUrl+'session/getcourselist?cid='+btoa(courseId));
}
usertopic(topicId){
  return this.http.get(this.rootUrl+'session/getttopiclist?cid='+btoa(topicId));
}

userbatchtype(batchtypeId){
  return this.http.get(this.rootUrl+'session/getbatchtypelist?cid='+btoa(batchtypeId));
}

userExam(ExamId){
  return this.http.get(this.rootUrl+'session/getexamtypelist?cid='+btoa(ExamId));
}

userstream(streamId){
  return this.http.get(this.rootUrl+'session/getstreamtypelist?cid='+btoa(streamId));
}

getstream(){
  return this.http.get(this.rootUrl+'session/getstreamlist');
}

uservenue(centerId){
  console.log('LLLLLL');
  console.log(centerId);
  return this.http.get(this.rootUrl+'session/getvenuelist?cid='+btoa(centerId));
}
userbranch(FormValue){
  console.log(FormValue.Center+'testbatch');
  const body = {
    centerId: FormValue.Center,
    courseId:FormValue.Course,
    batchtypeId:FormValue.BatchType,
    examId:FormValue.Exam,
    streamId:FormValue.stream,
  }
 
  return this.http.post(this.rootUrl + 'session/getbacthdrplist', body);
}

addstream(streamObj){
  const body = {
    streamName: streamObj.Stream,
    sessionId:streamObj.Session,
    centerId:streamObj.Center,
    courseId:streamObj.Course,
    batchtypeId:streamObj.BatchType,
    examId:streamObj.Exam,
    status:streamObj.Status,
    createdBy:streamObj.userid,
     shortName: streamObj.shortName,
    forTestSeries: streamObj.forTestSeries,
    detail: streamObj.detail
  }
 
  return this.http.post(this.rootUrl + 'session/addstream', body);

}

streamlist(start,end,searchtxt){
    return this.http.get(this.rootUrl+"session/streamlist?start="+start+"&end="+end+'&search='+searchtxt);
}

editstream(streamId){
  return this.http.get(this.rootUrl+"session/getstream?cid="+btoa(streamId));
}

editstreamm(streamObj,streamId){
  const body = {
    streamName: streamObj.Stream,
    sessionId:streamObj.Session,
    centerId:streamObj.Center,
    courseId:streamObj.Course,
    batchtypeId:streamObj.BatchType,
    examId:streamObj.Exam,
    status:streamObj.Status,
    createdBy:streamObj.userid,
    shortName: streamObj.shortName,
    forTestSeries: streamObj.forTestSeries,
    detail: streamObj.detail,
    id:streamId
  }
  return this.http.post(this.rootUrl + 'session/editstream', body);
}



delstream(streamId){
  const body = {
   id: streamId,
   isDeleted:1
 }
 return this.http.post(this.rootUrl + 'session/delstream', body);
}

//batch module

addbatch(batchObj){
  var starttimee=batchObj.starttime.hour+':'+batchObj.starttime.minute+':'+batchObj.starttime.second;
  var endtimee=batchObj.endtime.hour+':'+batchObj.endtime.minute+':'+batchObj.endtime.second;

  var startdate=batchObj.startdate.year+'-'+batchObj.startdate.month+'-'+batchObj.startdate.day;
  var enddate=batchObj.enddate.year+'-'+batchObj.enddate.month+'-'+batchObj.enddate.day;
  const body = {
    batchName: batchObj.batchName,
    rollnoprefix: batchObj.rollnoprefix,
    sessionId:batchObj.Session,
    centerId:batchObj.Center,
    courseId:batchObj.Course,
    batchtypeId:batchObj.BatchType,
    examId:batchObj.Exam,
    streamId:batchObj.stream,
    totalSeat:batchObj.totalseat,
    startdate:startdate,
    enddate:enddate,
    starttime:starttimee,
    endtime:endtimee,
    status:batchObj.Status,
    period:batchObj.Period,
    venueId:batchObj.Venue,
    venuecode:batchObj.Venuecode,
    createdBy:batchObj.userid
  }
 
  return this.http.post(this.rootUrl + 'session/addbatch', body);

}

editbatchh(batchObj,batchId){
  var starttimee=batchObj.starttime.hour+':'+batchObj.starttime.minute+':'+batchObj.starttime.second;
  var endtimee=batchObj.endtime.hour+':'+batchObj.endtime.minute+':'+batchObj.endtime.second;

  var startdate=batchObj.startdate.year+'-'+batchObj.startdate.month+'-'+batchObj.startdate.day;
  var enddate=batchObj.enddate.year+'-'+batchObj.enddate.month+'-'+batchObj.enddate.day;
  const body = {
    batchName: batchObj.batchName,
    rollnoprefix: batchObj.rollnoprefix,
    sessionId:batchObj.Session,
    centerId:batchObj.Center,
    courseId:batchObj.Course,
    batchtypeId:batchObj.BatchType,
    examId:batchObj.Exam,
    streamId:batchObj.stream,
    totalSeat:batchObj.totalseat,
    startdate:startdate,
    enddate:enddate,
    starttime:starttimee,
    endtime:endtimee,
    status:batchObj.Status,
    createdBy:batchObj.userid,
    period:batchObj.Period,
    venueId:batchObj.Venue,
    venuecode:batchObj.Venuecode,
    id:batchId
  }
  return this.http.post(this.rootUrl + 'session/editbatch', body);
}

batchlist(start,end,searchtxt){
  return this.http.get(this.rootUrl+"session/batchlist?start="+start+"&end="+end+'&search='+searchtxt);
}

editbatch(batchId){
  return this.http.get(this.rootUrl+"session/getbatch?cid="+btoa(batchId));
}
// delbatch(batchId){
//   return this.http.get(this.rootUrl+"delbatch?cid="+btoa(batchId));
// }

delbatch(batchId){
  const body = {
   id: batchId,
   isDeleted:1
 }
 return this.http.post(this.rootUrl + 'session/delbatch', body);
}
//subject
addsubject(subjectObj){
  const body = {
    subjectName: subjectObj.Subject,
    status:subjectObj.Status,
    createdBy:subjectObj.userid
  }
 
  return this.http.post(this.rootUrl + 'session/addsubject', body);

}

subjectlist(start,end,searchtxt){
  
  return this.http.get(this.rootUrl+"session/subjectlist?start="+start+"&end="+end+'&search='+searchtxt);
}

getsubject(subjectId){
  return this.http.get(this.rootUrl+"session/getsubject?cid="+btoa(subjectId));
}
editsubject(subjectObj,subjectId){
  const body = {
    subjectName: subjectObj.Subject,
    status:subjectObj.Status,
    createdBy:subjectObj.userid,
    id:subjectId
  }
  return this.http.post(this.rootUrl + 'session/editsubject', body);
}
delsubject(sujectId){
  const body = {
   id: sujectId,
   isDeleted:1
 }
 return this.http.post(this.rootUrl + 'session/delsubject', body);
}
//Venue

addvenue(venueObj){
  const body = {
    venueName: venueObj.Venue,
    centerId:venueObj.Center,
    status:venueObj.Status,
    createdBy:venueObj.userid
  }
 
  return this.http.post(this.rootUrl + 'session/addvenue', body);

}

venuelist(start,end,searchtxt){
  return this.http.get(this.rootUrl+"session/venuelist?start="+start+"&end="+end+'&search='+searchtxt);
}

getvenue(venueId){
  return this.http.get(this.rootUrl+"session/getvenue?cid="+btoa(venueId));
}
editvenue(venueObj,venueId){
  const body = {
    venueName: venueObj.Venue,
    centerId:venueObj.Center,
    status:venueObj.Status,
    createdBy:venueObj.userid,
    id:venueId
  }
  return this.http.post(this.rootUrl + 'session/editvenue', body);
}
delvenue(venueId){
  const body = {
   id: venueId,
   isDeleted:1
 }
 return this.http.post(this.rootUrl + 'session/delvenue', body);
}

importbatch(batch,user){
  const body = {
    batchs: batch,
    createdBy:user.id,
  }
  return this.http.post(this.rootUrl + 'session/importbatch', body);


}

addtopic(topicObj){
  return this.http.post(this.rootUrl + 'session/addtopic', topicObj);

}

addchapter(chapterObj){
  return this.http.post(this.rootUrl + 'session/addchapter', chapterObj);

}

chapterlist(chapterObj){
  return this.http.post(this.rootUrl + 'session/getchapterlist', chapterObj);
}
getchapter(chapterId){
  const body={
    chapterId:chapterId
  }
  return this.http.post(this.rootUrl + 'session/getchapter', body);

}
editchapter(chapterObj,id){
  const body={
    chapterObj:chapterObj,
    chapterId:id
  }
  return this.http.post(this.rootUrl + 'session/editchapter', body);
}
delchapter(chapterId){
  const body = {
    id: chapterId,
    isDeleted:1
  }
  return this.http.post(this.rootUrl + 'session/delchapter', body);

}

userchapter(Id){
  const body={
    subjectId:Id
  }
  return this.http.post(this.rootUrl+'session/getchapterdrplist',body);
}

topiclist(topicObj){
  return this.http.post(this.rootUrl + 'session/gettopiclist', topicObj);
}

gettopic(topicId){
  const body={
    topicId:topicId
  }
  return this.http.post(this.rootUrl + 'session/gettopic', body);

}


edittopic(topicObj,id){
  const body={
    topicObj:topicObj,
    topicId:id
  }
  return this.http.post(this.rootUrl + 'session/edittopic', body);
}

deltopic(topicId){
  const body = {
    id: topicId,
    isDeleted:1
  }
  return this.http.post(this.rootUrl + 'session/deltopic', body);

}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/session.service.ts